<div
  *ngIf="title || subtitle"
  [className]="isCollapsable ? 'offerings-container tablet-sticky' : 'offerings-container no-bottom-radius'"
  [style.border]="withBorder ? '2px solid #f7f7f7' : 'none'">
  <div class="offerings-title">{{ title }}</div>
  <div class="offerings-subtitle">{{ subtitle }}</div>
  <div *ngIf="showSearchBar" class="search-bar-wrapper">
    <mat-icon class="search-icon ml-auto ml-4">search</mat-icon>
    <input class="searchInput" [placeholder]="'csa.profile.search.offering' | translate" [formControl]="searchControl" />
    <img
      src="./../../../../assets/images/icons/clear.svg"
      id="searchClear"
      alt="Search clear"
      class="ml-auto mr-4 pointer clear"
      (click)="clearSearch()" />
  </div>
</div>

<collapsable
  *ngFor="let group of content; index as i"
  [withBorder]="withBorder"
  [searchMode]="searchMode"
  [title]="group.groupTitle"
  [isCollapsable]="isCollapsable"
  [isOpen]="group.isOpen || searchMode"
  (openCloseCollapsableEmitter)="openCollapsable(i)">
  <mat-checkbox
    *ngFor="let item of group.options"
    [value]="item"
    [checked]="item.selected"
    (change)="onOptionsChange(item)"
    class="option-display-inline"
    [ngClass]="optionsClassName"
    >{{ item.name | translate }}
  </mat-checkbox>
  <div id="no-results" *ngIf="searchMode && content && content[0] && !content[0].options?.length">
    {{ 'csa.offerings.search.no.results' | translate }}
  </div>
</collapsable>
